import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";

import TeamIcon from "@components/icons/TeamIcon";
import { CompetitionAverage } from "@data-types/sport-stats/SportStatsTypes";
import { Team, Tournament } from "@gp/models";

export const CompetitionAverages = observer(function CompetitionAverages(props: {
	title: string;
	data: CompetitionAverage[];
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) {
	const { t } = useTranslation();

	if (!props.data) return null;

	return (
		<div className="statistics__card">
			<div className="statistics__header">
				<span className="statistics__title">{props.title}</span>
			</div>
			<div className="statistics__body">
				<div className="statistics__row">
					<div className="statistics__col">
						<div className="statistics__team">
							<TeamIcon
                                showCountryFlag={props.tournament?.showCountryFlag}
                                flagCode={props.homeTeam?.countryCode}
                                jerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
                                opponentFlagCode={props.awayTeam?.countryCode}
                                opponentJerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
                                className="card--stats__icon u-icon--big"
                            />
							<span className="statistics__name statistics__name--left">
								{t("EVENT.OFFER.COMPETITOR_HOME")}
							</span>
						</div>
					</div>
					<div className="statistics__col">
						<div className="statistics__team">
							<span className="statistics__name statistics__name--right">
								{t("EVENT.OFFER.COMPETITOR_AWAY")}
							</span>
							<TeamIcon
                                showCountryFlag={props.tournament?.showCountryFlag}
                                flagCode={props.awayTeam?.countryCode}
                                jerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
                                opponentFlagCode={props.homeTeam?.countryCode}
                                opponentJerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
                                className="card--stats__icon u-icon--big"
                            />
						</div>
					</div>
				</div>

                {props.data.map((item, index) => (
                    <div className="statistics__row" key={index}>
                        <div className="statistics__col">
                            {item.home ?? "0"}
                        </div>
                        <div className="statistics__col">
                            {t(`EVENT.STATISTICS.STREAK_STATS.${item.abrv}`)}
                        </div>
                        <div className="statistics__col">
                            {item.away ?? "0"}
                        </div>
                    </div>
                ))}
            </div>
        </div>
	);
});
